import { Close } from "@material-ui/icons";
import React, { useState } from "react";
import styled from "styled-components";

const Container = styled.div`
  height: 10px;
  background-color: teal;
  color: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  font-weight: 500;
  padding: 10px;
`;

const Announcement = () => {
  const [clearAnnouncement, setClearAnnounement] = useState(false);
  const clearAnnounementHandler = () => {
    setClearAnnounement(true);
  };
  return (
    <>
      {!clearAnnouncement && (
        <Container>
          <p></p>
          <p>GET 50% OFF ON YOUR FIRST ORDER USE FIRST50 COUPON CODE</p>
          <Close
            onClick={clearAnnounementHandler}
            style={{
              cursor: "pointer"
            }}
          />
        </Container>
      )}
    </>
  );
};

export default Announcement;
